import { oauth } from "../utils";

export const ADD_ITEM_REQUEST = 'ADD_ITEM_REQUEST';
export const ADD_ITEM_SUCCESS = 'ADD_ITEM_SUCCESS';
export const HYDRATE_CATALOG_ITEM = 'HYDRATE_CATALOG_ITEM';
export const ADD_REDIRECT_ITEM_SUCCESS = 'ADD_REDIRECT_ITEM_SUCCESS';
export const ADD_ITEM_FAILURE = 'ADD_ITEM_FAILURE';
export const ADD_ITEM_CANCEL = 'ADD_ITEM_CANCEL';

export const UPDATE_ITEM_REQUEST = 'UPDATE_ITEM_REQUEST';
export const UPDATE_ITEM_SUCCESS = 'UPDATE_ITEM_SUCCESS';
export const UPDATE_ITEM_FAILURE = 'UPDATE_ITEM_FAILURE';

export const SIMPLE_UPDATE_ITEM_REQUEST = 'SIMPLE_UPDATE_ITEM_REQUEST';
export const SIMPLE_UPDATE_ITEM_SUCCESS = 'SIMPLE_UPDATE_ITEM_SUCCESS';
export const SIMPLE_UPDATE_ITEM_FAILURE = 'SIMPLE_UPDATE_ITEM_FAILURE';

export const COMPLEX_UPDATE_ITEM_REQUEST = 'COMPLEX_UPDATE_ITEM_REQUEST';
export const COMPLEX_UPDATE_ITEM_SUCCESS = 'COMPLEX_UPDATE_ITEM_SUCCESS';
export const COMPLEX_UPDATE_ITEM_FAILURE = 'COMPLEX_UPDATE_ITEM_FAILURE';

export const COMPLEX_UPDATE_BREAKDOWN_REQUEST = 'COMPLEX_UPDATE_BREAKDOWN_REQUEST';
export const COMPLEX_UPDATE_BREAKDOWN_SUCCESS = 'COMPLEX_UPDATE_BREAKDOWN_SUCCESS';
export const COMPLEX_UPDATE_BREAKDOWN_FAILURE = 'COMPLEX_UPDATE_BREAKDOWN_FAILURE';

export const COMPLEX_UPDATE_ITEM_COST_REQUEST = 'COMPLEX_UPDATE_ITEM_COST_REQUEST';
export const COMPLEX_UPDATE_ITEM_COST_SUCCESS = 'COMPLEX_UPDATE_ITEM_COST_SUCCESS';
export const COMPLEX_UPDATE_ITEM_COST_FAILURE = 'COMPLEX_UPDATE_ITEM_COST_FAILURE';

export const DELETE_ITEM_REQUEST = 'DELETE_ITEM_REQUEST';
export const DELETE_ITEM_SUCCESS = 'DELETE_ITEM_SUCCESS';
export const DELETE_ITEM_FAILURE = 'DELETE_ITEM_FAILURE';

export const ADD_ITEM_COST_REQUEST = 'ADD_ITEM_COST_REQUEST';
export const ADD_ITEM_COST_SUCCESS = 'ADD_ITEM_COST_SUCCESS';
export const ADD_ITEM_COST_FAILURE = 'ADD_ITEM_COST_FAILURE';

export const UPDATE_ITEM_COST_REQUEST = 'UPDATE_ITEM_COST_REQUEST';
export const UPDATE_ITEM_COST_SUCCESS = 'UPDATE_ITEM_COST_SUCCESS';
export const UPDATE_ITEM_COST_FAILURE = 'UPDATE_ITEM_COST_FAILURE';

export const DELETE_ITEM_COST_REQUEST = 'DELETE_ITEM_COST_REQUEST';
export const DELETE_ITEM_COST_SUCCESS = 'DELETE_ITEM_COST_SUCCESS';
export const DELETE_ITEM_COST_FAILURE = 'DELETE_ITEM_COST_FAILURE';

export const ADD_ITEM_LOCATION_REQUEST = 'ADD_ITEM_LOCATION_REQUEST';
export const ADD_ITEM_LOCATION_SUCCESS = 'ADD_ITEM_LOCATION_SUCCESS';
export const ADD_ITEM_LOCATION_FAILURE = 'ADD_ITEM_LOCATION_FAILURE';

export const UPDATE_ITEM_LOCATION_REQUEST = 'UPDATE_ITEM_LOCATION_REQUEST';
export const UPDATE_ITEM_LOCATION_SUCCESS = 'UPDATE_ITEM_LOCATION_SUCCESS';
export const UPDATE_ITEM_LOCATION_FAILURE = 'UPDATE_ITEM_LOCATION_FAILURE';

export const DELETE_ITEM_LOCATION_REQUEST = 'DELETE_ITEM_LOCATION_REQUEST';
export const DELETE_ITEM_LOCATION_SUCCESS = 'DELETE_ITEM_LOCATION_SUCCESS';
export const DELETE_ITEM_LOCATION_FAILURE = 'DELETE_ITEM_LOCATION_FAILURE';

export const UPDATE_ITEM_DECORATION_REQUEST = 'UPDATE_ITEM_DECORATION_REQUEST';
export const UPDATE_ITEM_DECORATION_SUCCESS = 'UPDATE_ITEM_DECORATION_SUCCESS';
export const UPDATE_ITEM_DECORATION_FAILURE = 'UPDATE_ITEM_DECORATION_FAILURE';

export const ADD_ITEM_BREAKDOWN_REQUEST = 'ADD_ITEM_BREAKDOWN_REQUEST';
export const ADD_ITEM_BREAKDOWN_SUCCESS = 'ADD_ITEM_BREAKDOWN_SUCCESS';
export const ADD_ITEM_BREAKDOWN_FAILURE = 'ADD_ITEM_BREAKDOWN_FAILURE';

export const UPDATE_ITEM_BREAKDOWN_REQUEST = 'UPDATE_ITEM_BREAKDOWN_REQUEST';
export const UPDATE_ITEM_BREAKDOWN_SUCCESS = 'UPDATE_ITEM_BREAKDOWN_SUCCESS';
export const UPDATE_ITEM_BREAKDOWN_FAILURE = 'UPDATE_ITEM_BREAKDOWN_FAILURE';

export const DELETE_ITEM_BREAKDOWN_REQUEST = 'DELETE_ITEM_BREAKDOWN_REQUEST';
export const DELETE_ITEM_BREAKDOWN_SUCCESS = 'DELETE_ITEM_BREAKDOWN_SUCCESS';
export const DELETE_ITEM_BREAKDOWN_FAILURE = 'DELETE_ITEM_BREAKDOWN_FAILURE';

export const ADD_ITEM_TAX_AMOUNT_REQUEST = 'ADD_ITEM_TAX_AMOUNT_REQUEST';
export const ADD_ITEM_TAX_AMOUNT_SUCCESS = 'ADD_ITEM_TAX_AMOUNT_SUCCESS';
export const ADD_ITEM_TAX_AMOUNT_FAILURE = 'ADD_ITEM_TAX_AMOUNT_FAILURE';

export const UPDATE_ITEM_TAX_AMOUNT_REQUEST = 'UPDATE_ITEM_TAX_AMOUNT_REQUEST';
export const UPDATE_ITEM_TAX_AMOUNT_SUCCESS = 'UPDATE_ITEM_TAX_AMOUNT_SUCCESS';
export const UPDATE_ITEM_TAX_AMOUNT_FAILURE = 'UPDATE_ITEM_TAX_AMOUNT_FAILURE';

export const DELETE_ITEM_TAX_AMOUNT_REQUEST = 'DELETE_ITEM_TAX_AMOUNT_REQUEST';
export const DELETE_ITEM_TAX_AMOUNT_SUCCESS = 'DELETE_ITEM_TAX_AMOUNT_SUCCESS';
export const DELETE_ITEM_TAX_AMOUNT_FAILURE = 'DELETE_ITEM_TAX_AMOUNT_FAILURE';

export const COPY_ITEM_REQUEST = 'COPY_ITEM_REQUEST';
export const COPY_ITEM_SUCCESS = 'COPY_ITEM_SUCCESS';
export const COPY_ITEM_FAILURE = 'COPY_ITEM_FAILURE';

export const COPY_ITEM_FROM_COLLECTION_REQUEST = 'COPY_ITEM_FROM_COLLECTION_REQUEST';
export const COPY_ITEM_FROM_COLLECTION_SUCCESS = 'COPY_ITEM_FROM_COLLECTION_SUCCESS';
export const COPY_ITEM_FROM_COLLECTION_FAILURE = 'COPY_ITEM_FROM_COLLECTION_FAILURE';

export const ADD_ITEM_COMMENT_REQUEST = 'ADD_ITEM_COMMENT_REQUEST';
export const ADD_ITEM_COMMENT_SUCCESS = 'ADD_ITEM_COMMENT_SUCCESS';
export const ADD_ITEM_COMMENT_FAILURE = 'ADD_ITEM_COMMENT_FAILURE';

export const DELETE_ITEM_COMMENT_REQUEST = 'DELETE_ITEM_COMMENT_REQUEST';
export const DELETE_ITEM_COMMENT_SUCCESS = 'DELETE_ITEM_COMMENT_SUCCESS';
export const DELETE_ITEM_COMMENT_FAILURE = 'DELETE_ITEM_COMMENT_FAILURE';

export const REORDER_ITEM_REQUEST = 'REORDER_ITEM_REQUEST';
export const REORDER_ITEM_SUCCESS = 'REORDER_ITEM_SUCCESS';
export const REORDER_ITEM_FAILURE = 'REORDER_ITEM_FAILURE';

export const REORDER_ITEM_BREAKDOWN_REQUEST = 'REORDER_ITEM_BREAKDOWN_REQUEST';
export const REORDER_ITEM_BREAKDOWN_SUCCESS = 'REORDER_ITEM_BREAKDOWN_SUCCESS';
export const REORDER_ITEM_BREAKDOWN_FAILURE = 'REORDER_ITEM_BREAKDOWN_FAILURE';

export const REORDER_ITEM_COST_REQUEST = 'REORDER_ITEM_COST_REQUEST';
export const REORDER_ITEM_COST_SUCCESS = 'REORDER_ITEM_COST_SUCCESS';
export const REORDER_ITEM_COST_FAILURE = 'REORDER_ITEM_COST_FAILURE';

export const REORDER_ITEM_LOCATION_REQUEST = 'REORDER_ITEM_LOCATION_REQUEST';
export const REORDER_ITEM_LOCATION_SUCCESS = 'REORDER_ITEM_LOCATION_SUCCESS';
export const REORDER_ITEM_LOCATION_FAILURE = 'REORDER_ITEM_LOCATION_FAILURE';

export const ADD_BREAKDOWN_COLOR_REQUEST = 'ADD_BREAKDOWN_COLOR_REQUEST';
export const ADD_BREAKDOWN_COLOR_SUCCESS = 'ADD_BREAKDOWN_COLOR_SUCCESS';
export const ADD_BREAKDOWN_COLOR_FAILURE = 'ADD_BREAKDOWN_COLOR_FAILURE';

export const ADD_BREAKDOWN_SIZE_REQUEST = 'ADD_BREAKDOWN_SIZE_REQUEST';
export const ADD_BREAKDOWN_SIZE_SUCCESS = 'ADD_BREAKDOWN_SIZE_SUCCESS';
export const ADD_BREAKDOWN_SIZE_FAILURE = 'ADD_BREAKDOWN_SIZE_FAILURE';

export const ADD_ITEM_COLOR_REQUEST = 'ADD_ITEM_COLOR_REQUEST';
export const ADD_ITEM_COLOR_SUCCESS = 'ADD_ITEM_COLOR_SUCCESS';
export const ADD_ITEM_COLOR_FAILURE = 'ADD_ITEM_COLOR_FAILURE';

export const ADD_ITEM_SIZE_REQUEST = 'ADD_ITEM_SIZE_REQUEST';
export const ADD_ITEM_SIZE_SUCCESS = 'ADD_ITEM_SIZE_SUCCESS';
export const ADD_ITEM_SIZE_FAILURE = 'ADD_ITEM_SIZE_FAILURE';

export const ADD_ITEM_SKU_REQUEST = 'ADD_ITEM_SKU_REQUEST';
export const ADD_ITEM_SKU_SUCCESS = 'ADD_ITEM_SKU_SUCCESS';
export const ADD_ITEM_SKU_FAILURE = 'ADD_ITEM_SKU_FAILURE';

export const DELETE_ITEM_COLOR_REQUEST = 'DELETE_ITEM_COLOR_REQUEST';
export const DELETE_ITEM_COLOR_SUCCESS = 'DELETE_ITEM_COLOR_SUCCESS';
export const DELETE_ITEM_COLOR_FAILURE = 'DELETE_ITEM_COLOR_FAILURE';

export const DELETE_ITEM_SIZE_REQUEST = 'DELETE_ITEM_SIZE_REQUEST';
export const DELETE_ITEM_SIZE_SUCCESS = 'DELETE_ITEM_SIZE_SUCCESS';
export const DELETE_ITEM_SIZE_FAILURE = 'DELETE_ITEM_SIZE_FAILURE';

export const DELETE_ITEM_SKU_REQUEST = 'DELETE_ITEM_SKU_REQUEST';
export const DELETE_ITEM_SKU_SUCCESS = 'DELETE_ITEM_SKU_SUCCESS';
export const DELETE_ITEM_SKU_FAILURE = 'DELETE_ITEM_SKU_FAILURE';

export const ADD_ITEM_IMAGE_REQUEST = 'ADD_ITEM_IMAGE_REQUEST';
export const ADD_ITEM_IMAGE_SUCCESS = 'ADD_ITEM_IMAGE_SUCCESS';
export const ADD_ITEM_IMAGE_FAILURE = 'ADD_ITEM_IMAGE_FAILURE';

export const UPDATE_ITEM_IMAGE_REQUEST = 'UPDATE_ITEM_IMAGE_REQUEST';
export const UPDATE_ITEM_IMAGE_SUCCESS = 'UPDATE_ITEM_IMAGE_SUCCESS';
export const UPDATE_ITEM_IMAGE_FAILURE = 'UPDATE_ITEM_IMAGE_FAILURE';

export const DELETE_ITEM_IMAGE_REQUEST = 'DELETE_ITEM_IMAGE_REQUEST';
export const DELETE_ITEM_IMAGE_SUCCESS = 'DELETE_ITEM_IMAGE_SUCCESS';
export const DELETE_ITEM_IMAGE_FAILURE = 'DELETE_ITEM_IMAGE_FAILURE';

export const UPDATE_PRODUCT_WARNINGS_REQUEST = 'UPDATE_PRODUCT_WARNINGS_REQUEST';
export const UPDATE_PRODUCT_WARNINGS_SUCCESS = 'UPDATE_PRODUCT_WARNINGS_SUCCESS';
export const UPDATE_PRODUCT_WARNINGS_FAILURE = 'UPDATE_PRODUCT_WARNINGS_FAILURE';

export const ADD_ITEM_WARNING_REQUEST = 'ADD_ITEM_WARNING_REQUEST';
export const ADD_ITEM_WARNING_SUCCESS = 'ADD_ITEM_WARNING_SUCCESS';
export const ADD_ITEM_WARNING_FAILURE = 'ADD_ITEM_WARNING_FAILURE';

export const UPDATE_ITEM_WARNING_REQUEST = 'UPDATE_ITEM_WARNING_REQUEST';
export const UPDATE_ITEM_WARNING_SUCCESS = 'UPDATE_ITEM_WARNING_SUCCESS';
export const UPDATE_ITEM_WARNING_FAILURE = 'UPDATE_ITEM_WARNING_FAILURE';

export const DELETE_ITEM_WARNING_REQUEST = 'DELETE_ITEM_WARNING_REQUEST';
export const DELETE_ITEM_WARNING_SUCCESS = 'DELETE_ITEM_WARNING_SUCCESS';
export const DELETE_ITEM_WARNING_FAILURE = 'DELETE_ITEM_WARNING_FAILURE';

export const ADD_ITEM_RETAIL_ADJUSTMENT_REQUEST = 'ADD_ITEM_RETAIL_ADJUSTMENT_REQUEST';
export const ADD_ITEM_RETAIL_ADJUSTMENT_SUCCESS = 'ADD_ITEM_RETAIL_ADJUSTMENT_SUCCESS';
export const ADD_ITEM_RETAIL_ADJUSTMENT_FAILURE = 'ADD_ITEM_RETAIL_ADJUSTMENT_FAILURE';

export const UPDATE_ITEM_RETAIL_ADJUSTMENT_REQUEST = 'UPDATE_ITEM_RETAIL_ADJUSTMENT_REQUEST';
export const UPDATE_ITEM_RETAIL_ADJUSTMENT_SUCCESS = 'UPDATE_ITEM_RETAIL_ADJUSTMENT_SUCCESS';
export const UPDATE_ITEM_RETAIL_ADJUSTMENT_FAILURE = 'UPDATE_ITEM_RETAIL_ADJUSTMENT_FAILURE';

export const UPDATE_ITEM_RETAIL_ADJUSTMENT_WITH_METADATA_REQUEST = 'UPDATE_ITEM_RETAIL_ADJUSTMENT_WITH_METADATA_REQUEST';
export const UPDATE_ITEM_RETAIL_ADJUSTMENT_WITH_METADATA_SUCCESS = 'UPDATE_ITEM_RETAIL_ADJUSTMENT_WITH_METADATA_SUCCESS';
export const UPDATE_ITEM_RETAIL_ADJUSTMENT_WITH_METADATA_FAILURE = 'UPDATE_ITEM_RETAIL_ADJUSTMENT_WITH_METADATA_FAILURE';

export const DELETE_ITEM_RETAIL_ADJUSTMENT_REQUEST = 'DELETE_ITEM_RETAIL_ADJUSTMENT_REQUEST';
export const DELETE_ITEM_RETAIL_ADJUSTMENT_SUCCESS = 'DELETE_ITEM_RETAIL_ADJUSTMENT_SUCCESS';
export const DELETE_ITEM_RETAIL_ADJUSTMENT_FAILURE = 'DELETE_ITEM_RETAIL_ADJUSTMENT_FAILURE';

export const CHECK_ITEM_IN_COLLECTION_REQUEST = 'CHECK_ITEM_IN_COLLECTION_REQUEST';
export const CHECK_ITEM_IN_COLLECTION_SUCCESS = 'CHECK_ITEM_IN_COLLECTION_SUCCESS';
export const CHECK_ITEM_IN_COLLECTION_FAILURE = 'CHECK_ITEM_IN_COLLECTION_FAILURE';

export const UPDATE_POPUP_IMAGE_REQUEST = 'UPDATE_POPUP_IMAGE_REQUEST';
export const UPDATE_POPUP_IMAGE_SUCCESS = 'UPDATE_POPUP_IMAGE_SUCCESS';
export const UPDATE_POPUP_IMAGE_FAILURE = 'UPDATE_POPUP_IMAGE_FAILURE';

export const GET_ITEM_VARIANTS_SUCCESS = 'GET_ITEM_VARIANTS_SUCCESS';
export const ADD_VARIANT_SUCCESS = 'ADD_VARIANT_SUCCESS';
export const ADD_VARIANT_FAILURE = 'ADD_VARIANT_FAILURE';
export const DELETE_VARIANT_SUCCESS = 'DELETE_VARIANT_SUCCESS';
export const DELETE_VARIANT_FAILURE = 'DELETE_VARIANT_FAILURE';
export const UPDATE_VARIANT_SUCCESS = 'UPDATE_VARIANT_SUCCESS';
export const UPDATE_VARIANT_FAILURE = 'UPDATE_VARIANT_FAILURE';

export const VALIDATE_EXTERNAL_ITEM_SUCCESS = 'VALIDATE_EXTERNAL_ITEM_SUCCESS';
export const VALIDATE_EXTERNAL_ITEM_FAILURE = 'VALIDATE_EXTERNAL_ITEM_FAILURE';

export const getItemVariantsSuccess = (item_id, variants) => ({
  type: GET_ITEM_VARIANTS_SUCCESS,
  payload: {
    item_id,
    variants,
  },
});

export const getItemVariants = (item_id) => (dispatch) => {
  return oauth("GET", "item-variant", { item_id }).then(({ json }) =>
    dispatch(getItemVariantsSuccess(item_id, json.item_variants))
  );
};

const addVariantSuccess = (variant, item_id) => ({
  type: ADD_VARIANT_SUCCESS,
  payload: {
    variant,
    item_id
  },
});

const addVariantFailure = (item_id, error) => ({
  type: ADD_VARIANT_FAILURE,
  payload: {
    item_id,
    error,
  },
});

export const createAddVariant =
  (item_id, { product_sku_id = null, color_id = null, size_id = null }) =>
  (dispatch) => {
    const data = product_sku_id ?
      {
        item_id,
        product_sku_id
      } : {
        item_id,
        color_id,
        size_id,
      };

    return oauth("POST", `item-variant`, data).then(
      ({ json }) => dispatch(addVariantSuccess(json.item_variant, item_id)),
      (error) => dispatch(addVariantFailure(item_id, error))
    );
  };

const deleteVariantSuccess = (item_id, item_variant_id) => ({
  type: DELETE_VARIANT_SUCCESS,
  payload: {
      item_id,
      item_variant_id
  },
});

const deleteVariantFailure = (itemId) => ({
  type: DELETE_VARIANT_FAILURE,
  payload: {
      itemId
  },
});

export const deleteVariant = (item_id, item_variant_id) => (dispatch) =>{
    oauth('DELETE', `item-variant/${item_variant_id}`).then(
        ({ json }) => dispatch(deleteVariantSuccess(item_id, item_variant_id)),
        ({ json }) => dispatch(deleteVariantFailure(item_id, item_variant_id))
      );
};

const updateVariantSuccess = (item_id, item_variant_id, external_id) => ({
  type: UPDATE_VARIANT_SUCCESS,
  payload: {
    item_id,
      item_variant_id,
      external_id
  },
});

const updateVariantFailure = (item_id, item_variant_id, external_id) => ({
  type: UPDATE_VARIANT_FAILURE,
  payload: {
    item_id,
      item_variant_id,
      external_id
  },
});

export const updateVariant = (item_id, item_variant_id, external_id) => (dispatch) => {
  return oauth('PUT', `item-variant/${item_variant_id}`, { external_id }).then(
    ({ json }) => {
      dispatch(updateVariantSuccess(item_id, item_variant_id, external_id));
    },
    (error) => {
      dispatch(updateVariantFailure(item_id, item_variant_id, external_id));
      return Promise.reject(error);
    }
  );
};

const validateExternalItemSuccess = (item_id, item_validation) => ({
  type: VALIDATE_EXTERNAL_ITEM_SUCCESS,
  payload: {
    item_id,
    item_validation,
  },
});

const validateExternalItemFailure = (item_id, error) => ({
  type: VALIDATE_EXTERNAL_ITEM_FAILURE,
  payload: {
    item_id,
    error,
  },
});

export const validateExternalItem = (item_id) => (dispatch) => {
  return oauth("GET", 'item/validate-shopify-item', { item_id }).then(
    ({ json }) => dispatch(validateExternalItemSuccess(item_id, json.variants)),
    (error) => dispatch(validateExternalItemFailure(item_id, error))
  );
};

export const getUpgradePromoStandardsProductTaskStatus = (
  item_id,
  order_id
) => (dispatch) => {
  const data = {
    actionName: 'get-upgrade-ps-product-task-status',
    item_id,
    order_id
  };

  return oauth('GET', 'item', data, null, null, null, false).then(
    ({ json }) => {
      const { item, deleted_item_id, order, artworks } = json;

      if (item) {
        dispatch({
          type: ADD_ITEM_SUCCESS,
          payload: {
            item: item,
            order: order,
            items: [],
            artworks: artworks || []
          }
        });
      }

      if (deleted_item_id) {
        dispatch({
          type: DELETE_ITEM_SUCCESS,
          payload: {
            item_id: deleted_item_id,
            order: order,
          }
        });
      }

      return json;
    },
    (error) => {
      return null;
    }
  );
};